
export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,

  /**
   * api 的根路径
   */
  baseMonitor: 'service-paas-monitor/',
  baseUrlHot: '/hot',
  // baseUrlHot: '/',
  // baseUrl: '/api',
  baseUrl: '/',
  baseSaas: 'service-paas-analysis/',
  baseVideo: 'service-paas-video/',
  baseIntellect: 'service-paas-cmdctrl/',
  baseUrlMap: '/lbrservice',

  // 网关
  authService: 'auth-service/',
  // authService: '',

  /**
   * 是否使用模拟数据
   */
  useMock: false,

  timer: null, // 定义全局参数，用户定时任务

  /**
   * 密钥
   */
  key: 'hundunyun2020',

  /**
   * 偏移量
   */
  iv: '12345678',

  /**
   * 基础主题色
   */
  DEFAULT_THEME: '#006cff'
}



// WEBPACK FOOTER //
// ./src/config/index.js